import React from 'react';

import MojitoApplications from 'mojito/applications';

import {ensureHierarchy} from '#core/utils/config-utils.js';
import {removeStartingSlash} from '#core/utils/url-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {SearchPage} from './search-page.jsx';
import {searchFactory} from './search.factory.js';

import SCHEMA from './search.schema.yaml';
import PALETTE_SCHEMA from './search.palette-schema.yaml';

const {RouterStore} = MojitoApplications.Common;

class SearchFeature extends AbstractVisualFeature {
    get name() {
        return 'Search';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get configSchema() {
        return SCHEMA;
    }

    get searchOptions() {
        return this.config.searchOptions;
    }

    updateViewsConfig(viewsConfig) {
        const RoutingView = ensureHierarchy(viewsConfig, 'RoutingView');
        const routeResolver = RouterStore.routeResolverFactory.getRouteResolver();

        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push({
            path: routeResolver.enrichWithRoot(removeStartingSlash(this.config.searchPagePath)),
            component: () => <SearchPage />,
        });

        super.updateViewsConfig(viewsConfig);
    }

    getSerializableVisualConfig(PALETTE) {
        return searchFactory(PALETTE);
    }
}

export const Search = new SearchFeature(allVisuals);
